import React from "react";

// Mui Styles
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";

import Box from "@mui/material/Box";

// CSS
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import DataTable from "@/components/dataTable";
import { questionnaireConfigTableColumn } from "@/config/tableColumnConfig";

// Fetch
import { getQuestionnarieSettings } from "@/fetch/fetchQuestionnarie";

// Mui Icon
import IconButton from "@mui/material/IconButton";
import { AddOutlined } from "@mui/icons-material";

// Moment
import Moment from "moment";
import "moment/locale/zh-hk";
import { extendMoment } from "moment-range";

import _ from "lodash";

const QuestionnaireConfigPage = (props) => {
  const { open, setOpen } = props;
  const moment = extendMoment(Moment);

  // Navigate
  const navigate = useNavigate();

  // States
  const [dataTableLoading, setDataTableLoading] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [dataRows, setDataRows] = React.useState([]);

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      const data = await getQuestionnarieSettings();
      if (data.results && data.data.length > 0) {
        setDataRows(data.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setDataTableLoading(false);
    }
  };

  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };

  React.useEffect(() => {
    fetchAll();
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="StaffManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`問卷表格設定`}
        history={() => navigate(-1)}
        children={
          <div>
            <IconButton
              component="label"
              onClick={() => navigate("/questionnaireConfig/Create")}
            >
              <AddOutlined />
            </IconButton>
          </div>
        }
      />

      <StyledPaper page={"yes"}>
        <ThemeProvider theme={{}}>
          <Box sx={{ width: "100%" }}>
            <DataTable
              loading={dataTableLoading}
              // newEditingApi={true}
              rows={dataRows}
              columns={questionnaireConfigTableColumn}
              pageSize={100}
              Toolbar={() => {}}
              onRowClick={(param) => {
                navigate(`/questionnaireConfig/Update/${param.id}`);
              }}
            />
          </Box>
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default QuestionnaireConfigPage;
